/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class CustomColorAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class CustomColorAPI {

		/**
		 * @function CustomColorAPI#registerProvider
		 * @description Register a provider as a data point actions provider
		 * @param {provider} provider DataPointAction provider to register and contribute to data point actions
		 */
		registerProvider( /* provider */ ) {}

		/**
		 * @function CustomColorAPI#deregisterProvider
		 * @description Deregister a provider
		 * @param {provider} provider DataPointAction provider to deregister and remove from data point actions
		 */
		deregisterProvider( /* provider */ ) {}

		/**
		 * @function CustomColorAPI#getUsedCustomColors
		 * @description retrieve a list of custom colors to save
		 * @return [CustomColor]
		 */
		getUsedCustomColors() { }
	}
	return CustomColorAPI;
});
